import {
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  println2shhhgwwt4c61 as println,
  StringBuildermazzzhj6kkai as StringBuilder,
  joinTo3533moo9lcgda as joinTo,
  protoOf180f3jzyo7rfj as protoOf,
  replaceqbix900hl8kl as replace,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  HashMap1a0ld5kgwhmhv as HashMap,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from './kotlin-kotlin-stdlib.mjs';
import { Companion_getInstancegk7jn4e7je7g as Companion_getInstance } from './korlibs-platform-root-korlibs-platform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Color extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.i45_1 = index;
  }
}
class AnsiEscape {}
function appendAnsiScape(_this__u8e3s4, code, extra, char) {
  _this__u8e3s4.hc(_Char___init__impl__6a9atx(27));
  _this__u8e3s4.hc(_Char___init__impl__6a9atx(91));
  _this__u8e3s4.rh(code);
  if (!(extra == null)) {
    _this__u8e3s4.gc(extra);
  }
  _this__u8e3s4.hc(char);
  return _this__u8e3s4;
}
function appendAnsiScape$default(_this__u8e3s4, code, extra, char, $super) {
  extra = extra === VOID ? null : extra;
  char = char === VOID ? _Char___init__impl__6a9atx(109) : char;
  return $super === VOID ? this.j45(_this__u8e3s4, code, extra, char) : appendAnsiScape(_this__u8e3s4, code, extra, char);
}
function appendReset(_this__u8e3s4) {
  return this.k45(_this__u8e3s4, 0);
}
function appendFgColor(_this__u8e3s4, color, bright) {
  return this.k45(_this__u8e3s4, 30 + color.i45_1 | 0, bright ? ';1' : null);
}
function appendFgColor$default(_this__u8e3s4, color, bright, $super) {
  bright = bright === VOID ? false : bright;
  return $super === VOID ? this.m45(_this__u8e3s4, color, bright) : appendFgColor(_this__u8e3s4, color, bright);
}
class Kind extends Enum {
  constructor(name, ordinal, level, color) {
    super(name, ordinal);
    this.q45_1 = level;
    this.r45_1 = color;
  }
}
class BaseConsole {
  t45(kind, msg) {
    var hook = baseConsoleHook;
    if (!(hook == null)) {
      hook(kind, msg, BaseConsole$logInternal$ref(this));
    } else {
      this.s45(kind, msg.slice());
    }
  }
  s45(kind, msg) {
    println(this.u45(kind, msg.slice()));
  }
  u45(kind, msg) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.logger.BaseConsole.logToString.<anonymous>' call
    var color = kind.r45_1;
    if (!(color == null)) {
      this.n45(this_0, color);
    }
    joinTo(msg, this_0, ', ');
    if (!(color == null)) {
      this.l45(this_0);
    }
    return this_0.toString();
  }
  v45(msg) {
    return this.t45(Kind_LOG_getInstance(), msg.slice());
  }
  w45(msg) {
    return this.t45(Kind_WARN_getInstance(), msg.slice());
  }
  x45(msg) {
    return this.t45(Kind_ERROR_getInstance(), msg.slice());
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.logger.Companion.BY_NAME.<anonymous>' call
      var tmp$ret$0 = element.o3_1;
      destination.k3(tmp$ret$0, element);
    }
    tmp.y45_1 = destination;
  }
  cj(name) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = name.toUpperCase();
    var tmp0_elvis_lhs = this.y45_1.e3(tmp$ret$1);
    return tmp0_elvis_lhs == null ? Level_NONE_getInstance() : tmp0_elvis_lhs;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    this.z45_1 = new Object();
    this.a46_1 = HashMap.a9();
    this.b46_1 = null;
    this.c46_1 = DefaultLogOutput_instance;
  }
  g26(name) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.z45_1;
    var normalizedName = normalizeName(Companion_getInstance_1(), name);
    if (Companion_getInstance_1().a46_1.e3(normalizedName) == null) {
      var logger = new Logger(name, normalizedName, true);
      var tmp0_safe_receiver = get_miniEnvironmentVariablesUC().e3('LOG_' + normalizedName);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.logger.Companion.invoke.<anonymous>.<anonymous>' call
        logger.j46(Companion_getInstance_0().cj(tmp0_safe_receiver));
      }
      if (Companion_getInstance_1().a46_1.j1()) {
        var tmp1_safe_receiver = get_miniEnvironmentVariablesUC().e3('LOG_LEVEL');
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.logger.Companion.invoke.<anonymous>.<anonymous>' call
          Companion_getInstance_1().b46_1 = Companion_getInstance_0().cj(tmp1_safe_receiver);
        }
      }
      // Inline function 'kotlin.collections.set' call
      Companion_getInstance_1().a46_1.k3(normalizedName, logger);
    }
    return ensureNotNull(Companion_getInstance_1().a46_1.e3(normalizedName));
  }
}
class Level extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.m46_1 = index;
  }
}
class ConsoleLogOutput {
  n46(logger, level, msg) {
    switch (level.p3_1) {
      case 2:
        Console_getInstance().x45([logger.d46_1, msg]);
        break;
      case 3:
        Console_getInstance().w45([logger.d46_1, msg]);
        break;
      default:
        Console_getInstance().v45([logger.d46_1, msg]);
        break;
    }
  }
}
class Logger {
  constructor(name, normalizedName, dummy) {
    Companion_getInstance_1();
    this.d46_1 = name;
    this.e46_1 = normalizedName;
    this.f46_1 = dummy;
    this.g46_1 = null;
    this.h46_1 = null;
    this.i46_1 = null;
  }
  j46(value) {
    this.h46_1 = value;
  }
  o46() {
    var tmp0_elvis_lhs = this.h46_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? Companion_getInstance_1().b46_1 : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Level_WARN_getInstance() : tmp1_elvis_lhs;
  }
  p46() {
    var tmp0_elvis_lhs = this.i46_1;
    return tmp0_elvis_lhs == null ? Companion_getInstance_1().c46_1 : tmp0_elvis_lhs;
  }
  q46(level) {
    return level.m46_1 <= this.o46().m46_1;
  }
  r46(level, msg) {
    this.p46().n46(this, level, msg);
  }
}
class Console extends BaseConsole {
  constructor() {
    Console_instance = null;
    super();
    Console_instance = this;
  }
  s45(kind, msg) {
    switch (kind.p3_1) {
      case 0:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 1:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.warn.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 2:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.info.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 3:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 4:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 5:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
}
class DefaultLogOutput {
  n46(logger, level, msg) {
    return ConsoleLogOutput_instance.n46(logger, level, msg);
  }
}
//endregion
var Color_BLACK_instance;
var Color_RED_instance;
var Color_GREEN_instance;
var Color_YELLOW_instance;
var Color_BLUE_instance;
var Color_PURPLE_instance;
var Color_CYAN_instance;
var Color_WHITE_instance;
var Color_entriesInitialized;
function Color_initEntries() {
  if (Color_entriesInitialized)
    return Unit_instance;
  Color_entriesInitialized = true;
  Color_BLACK_instance = new Color('BLACK', 0, 0);
  Color_RED_instance = new Color('RED', 1, 1);
  Color_GREEN_instance = new Color('GREEN', 2, 2);
  Color_YELLOW_instance = new Color('YELLOW', 3, 3);
  Color_BLUE_instance = new Color('BLUE', 4, 4);
  Color_PURPLE_instance = new Color('PURPLE', 5, 5);
  Color_CYAN_instance = new Color('CYAN', 6, 6);
  Color_WHITE_instance = new Color('WHITE', 7, 7);
}
function Color_RED_getInstance() {
  Color_initEntries();
  return Color_RED_instance;
}
function Color_GREEN_getInstance() {
  Color_initEntries();
  return Color_GREEN_instance;
}
function Color_YELLOW_getInstance() {
  Color_initEntries();
  return Color_YELLOW_instance;
}
function Color_BLUE_getInstance() {
  Color_initEntries();
  return Color_BLUE_instance;
}
function Color_CYAN_getInstance() {
  Color_initEntries();
  return Color_CYAN_instance;
}
var baseConsoleHook;
var Kind_ERROR_instance;
var Kind_WARN_instance;
var Kind_INFO_instance;
var Kind_DEBUG_instance;
var Kind_TRACE_instance;
var Kind_LOG_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_ERROR_instance = new Kind('ERROR', 0, 0, Color_RED_getInstance());
  Kind_WARN_instance = new Kind('WARN', 1, 1, Color_YELLOW_getInstance());
  Kind_INFO_instance = new Kind('INFO', 2, 2, Color_BLUE_getInstance());
  Kind_DEBUG_instance = new Kind('DEBUG', 3, 3, Color_CYAN_getInstance());
  Kind_TRACE_instance = new Kind('TRACE', 4, 4, Color_GREEN_getInstance());
  Kind_LOG_instance = new Kind('LOG', 5, 5, null);
}
function BaseConsole$logInternal$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.s45(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'logInternal';
  return l;
}
function Kind_ERROR_getInstance() {
  Kind_initEntries();
  return Kind_ERROR_instance;
}
function Kind_WARN_getInstance() {
  Kind_initEntries();
  return Kind_WARN_instance;
}
function Kind_LOG_getInstance() {
  Kind_initEntries();
  return Kind_LOG_instance;
}
var _miniEnvironmentVariablesUC;
function normalizeName($this, name) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  return replace(replace(name, _Char___init__impl__6a9atx(46), _Char___init__impl__6a9atx(95)), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(95)).toUpperCase();
}
var Level_NONE_instance;
var Level_FATAL_instance;
var Level_ERROR_instance;
var Level_WARN_instance;
var Level_INFO_instance;
var Level_DEBUG_instance;
var Level_TRACE_instance;
var Companion_instance;
function Companion_getInstance_0() {
  Level_initEntries();
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function values() {
  return [Level_NONE_getInstance(), Level_FATAL_getInstance(), Level_ERROR_getInstance(), Level_WARN_getInstance(), Level_INFO_getInstance(), Level_DEBUG_getInstance(), Level_TRACE_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'NONE':
      return Level_NONE_getInstance();
    case 'FATAL':
      return Level_FATAL_getInstance();
    case 'ERROR':
      return Level_ERROR_getInstance();
    case 'WARN':
      return Level_WARN_getInstance();
    case 'INFO':
      return Level_INFO_getInstance();
    case 'DEBUG':
      return Level_DEBUG_getInstance();
    case 'TRACE':
      return Level_TRACE_getInstance();
    default:
      Level_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
var Level_entriesInitialized;
function Level_initEntries() {
  if (Level_entriesInitialized)
    return Unit_instance;
  Level_entriesInitialized = true;
  Level_NONE_instance = new Level('NONE', 0, 0);
  Level_FATAL_instance = new Level('FATAL', 1, 1);
  Level_ERROR_instance = new Level('ERROR', 2, 2);
  Level_WARN_instance = new Level('WARN', 3, 3);
  Level_INFO_instance = new Level('INFO', 4, 4);
  Level_DEBUG_instance = new Level('DEBUG', 5, 5);
  Level_TRACE_instance = new Level('TRACE', 6, 6);
  Companion_getInstance_0();
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
var ConsoleLogOutput_instance;
function ConsoleLogOutput_getInstance() {
  return ConsoleLogOutput_instance;
}
function Level_NONE_getInstance() {
  Level_initEntries();
  return Level_NONE_instance;
}
function Level_FATAL_getInstance() {
  Level_initEntries();
  return Level_FATAL_instance;
}
function Level_ERROR_getInstance() {
  Level_initEntries();
  return Level_ERROR_instance;
}
function Level_WARN_getInstance() {
  Level_initEntries();
  return Level_WARN_instance;
}
function Level_INFO_getInstance() {
  Level_initEntries();
  return Level_INFO_instance;
}
function Level_DEBUG_getInstance() {
  Level_initEntries();
  return Level_DEBUG_instance;
}
function Level_TRACE_getInstance() {
  Level_initEntries();
  return Level_TRACE_instance;
}
function get_miniEnvironmentVariablesUC() {
  if (_miniEnvironmentVariablesUC == null) {
    // Inline function 'kotlin.collections.mapKeys' call
    var this_0 = get_miniEnvironmentVariables();
    // Inline function 'kotlin.collections.mapKeysTo' call
    var destination = LinkedHashMap.xc(mapCapacity(this_0.g1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_iterator = this_0.u1().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.logger.<get-miniEnvironmentVariablesUC>.<anonymous>' call
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = element.v1().toUpperCase();
      // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
      var tmp$ret$3 = element.w1();
      destination.k3(tmp, tmp$ret$3);
    }
    _miniEnvironmentVariablesUC = destination;
  }
  return ensureNotNull(_miniEnvironmentVariablesUC);
}
function get_miniEnvironmentVariables() {
  return Companion_getInstance().r23();
}
var Console_instance;
function Console_getInstance() {
  if (Console_instance === VOID)
    new Console();
  return Console_instance;
}
var DefaultLogOutput_instance;
function DefaultLogOutput_getInstance() {
  return DefaultLogOutput_instance;
}
//region block: post-declaration
initMetadataForClass(Color, 'Color');
initMetadataForInterface(AnsiEscape, 'AnsiEscape');
initMetadataForClass(Kind, 'Kind');
protoOf(BaseConsole).j45 = appendAnsiScape;
protoOf(BaseConsole).k45 = appendAnsiScape$default;
protoOf(BaseConsole).l45 = appendReset;
protoOf(BaseConsole).m45 = appendFgColor;
protoOf(BaseConsole).n45 = appendFgColor$default;
initMetadataForClass(BaseConsole, 'BaseConsole', BaseConsole, VOID, [AnsiEscape]);
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForClass(Level, 'Level');
initMetadataForObject(ConsoleLogOutput, 'ConsoleLogOutput');
initMetadataForClass(Logger, 'Logger');
initMetadataForObject(Console, 'Console');
initMetadataForObject(DefaultLogOutput, 'DefaultLogOutput');
//endregion
//region block: init
baseConsoleHook = null;
_miniEnvironmentVariablesUC = null;
ConsoleLogOutput_instance = new ConsoleLogOutput();
DefaultLogOutput_instance = new DefaultLogOutput();
//endregion
//region block: exports
export {
  Level_DEBUG_getInstance as Level_DEBUG_getInstancewzibhbcrmy7h,
  Level_ERROR_getInstance as Level_ERROR_getInstance18552yzhsfztk,
  Level_INFO_getInstance as Level_INFO_getInstance3huxkjtm54h8u,
  Level_TRACE_getInstance as Level_TRACE_getInstance1ni95vo21pald,
  Level_WARN_getInstance as Level_WARN_getInstance2cg04z8rod8ga,
  Console_getInstance as Console_getInstance8lqb2pbph5yn,
  Companion_getInstance_1 as Companion_getInstance3qvmjlq9y5ia6,
  valueOf as valueOf3aj0dpb8xpu5n,
};
//endregion
